import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import {observer} from "mobx-react"
import BienStore from "../BienStore"
import axios from "axios"

@observer
class Confirm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      valid: false
    };
  }
  componentDidMount(){

  }
  saveBien(e){
    e.preventDefault()
    BienStore.saveToServer()
  }
  render () {

    return (
      <React.Fragment>
      <h2 className="center">Récapitulatif</h2>
      <div className="row">
      <div className="col s12 m8">
      <table className="striped bordered">
        <thead>
          <tr>
            <th>Titre</th>
            <td>Données</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Adresse</td>
            <td>{BienStore.elements["adresse"]} {BienStore.elements["numero"]} {BienStore.elements["cp"]} {BienStore.elements["ville"]} {BienStore.elements["pays"]}</td>
          </tr>
          <tr>
            <td>Type</td>
            <td>{BienStore.elements["typedebien"]} </td>
          </tr>
          <tr>
            <td>Nombre d'étages</td>
            <td>{BienStore.elements["etages"]} </td>
          </tr>
          <tr>
            <td>age</td>
            <td>{BienStore.elements["plusde10ans"]==true ? "plus de 10 ans" : "moins de 10 ans"} </td>
          </tr>
          <tr>
            <td>Meuble</td>
            <td>{BienStore.elements["meuble"] == true ? "meublé" : "vide"} </td>
          </tr>
          <tr>
            <td>Compteurs electricite</td>
            <td>{BienStore.elements["electricite"] == true ? BienStore.elements["compteurelectricite"] : "Pas d'électrité dans ce bien"} </td>
          </tr>
           <tr>
            <td>Compteurs eau</td>
            <td>{BienStore.elements["eauchaudfroidsepare"] == true ? BienStore.elements["compteureaufroide"]+" - "+BienStore.elements["compteureauchaude"] : BienStore.elements["compteureau"]} </td>
          </tr>
          <tr>
            <td>Compteurs gaz</td>
            <td>{BienStore.elements["gaz"] == true ? BienStore.elements["compteurgaz"] : "Pas de gaz"} </td>
          </tr>
          {Object.keys(BienStore.pieces).map((key,index)=>(
            <tr key={index}>
              <td>{BienStore.pieces[key].titre}</td>
              <td>{BienStore.pieces[key].quantite}</td>
            </tr>
            ))}
        </tbody>
      </table>

      </div>
      <div className="col s12 m4 center" style={styles.fullheight}>
        <p style={styles.btn}><a href=""  className="btn btn-large" onClick={this.saveBien}>Terminer</a></p>
      </div>
      </div>

      </React.Fragment>
    );
  }
}

export default Confirm
const styles = {
  btn: {
    position: "sticky",
    top: "100px"
  },
  fullheight: {
    height: "100vh"
  }
}
